import { createContext } from "react";

export const TabsContext = createContext({
  renderSearchInHeader: false,
  openFilterDrawer: false,
  setOpenFilterDrawer: () => {},
  syncFiltersToParent: () => {},
  dealsScrollRef: null,
  isActive: false,
  followingFilters: {
    timeOfDay: "",
    date: "",
    area: "",
    category: "",
    discountType: "",
    priceBand: "",
  },
});
